export default class Assinatura {
    constructor(){
        this.plano = ''
        this.formaPagamento = ''
        this.dataAssinatura = ''
        //this.dataPagamento = ''
        this.status = ''
        this.qtdParcelas = ''
        this.observacao = ''
        this.promocional = ''
    }

}